<!--
 * @Author: 温静 （wenjing@feihe.com）
 * @Date: 2022-03-28 10:12:30
 * @LastEditors: xuhuining
 * @LastEditTime: 2022-08-02 11:16:27
 * @Description: 星妈课堂课程预约未注册用户提示弹窗/更多工具注册享受VIP 弹窗
-->
<template>
  <div class="mask" @touchmove.prevent @mousewheel.prevent>
    <div class="register_box">
      <div class="register_con" :style="{backgroundImage:'url('+(imgUrl)+')'}">
        <p>{{ text }}</p>
        <button @click="goRegister">马上注册</button>
      </div>
      <i @click="close"></i>
    </div>
  </div>
</template>
<script>
import { globalGoLogin } from "@/assets/js/common.js";
export default {
  name: "registerCard",
  props: {
    text: {
      type: String,
      default: '注册后才可以开通预约提醒功能～'
    },
    imgUrl: {
      type: String,
      default: require('@/assets/images/nweHome/toast2.png')
    }
  },
  methods: {
    // 去登录注册页面
    goRegister() {
      globalGoLogin()
      // this.$router.push({ path: '/phoneLogin?redirect=' + window.location.href })
    },
    // 点击关闭
    close() {
      this.$emit("close");
    }
  }
}
</script>
<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.54);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .register_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .register_con {
      width: 242px;
      height: 134px;
      // background: url("../../assets/images/nweHome/toast2.png") no-repeat;
      background-repeat: no-repeat;
      background-size: 290px 320px;
      padding: 162px 24px 24px;
      text-align: center;
      p {
        font-size: 20px;
        color:#666;
        line-height: 28px;
      }
      button {
        width: 244px;
        height: 50px;
        margin-top: 26px;
        border: none;
        background: linear-gradient(270deg, #F0BA39 0%, #FBCF6F 100%);
        box-shadow: 0px 4px 8px 0px rgba(231, 170, 28, 0.3);
        border-radius: 25px;
        font-size: 18px;
        color: #fff;
      }
    }
    i {
      margin-top:30px;
      width: 24px;
      height: 24px;
      background: url("../../assets/images/nweHome/close.png") no-repeat;
      background-size: contain;
      display: block;
    }
  }
}
</style>
